
export interface AnalyticsEvent {
  id: number;
  event: EventType;
  date: Date;
  linkedObject: number | null;
  count: number;
}

export enum EventType {
  Installation = 0,
  AppStart = 1,
  InfoPage = 2,
  ContactPage = 3,
  Push = 4
}
